module.exports = __webpack_public_path__ + "right_icon.png?b1c854e45f84afe2d79b4adef10a7d1c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/right_icon.png
// module id = 143
// module chunks = 0